module.exports = __webpack_public_path__ + "img/collar width.d0bbeff7.png";